
/* ----------------------------------------------------
   JCG LUXURY WISHLIST GLOBAL HANDLER & SYNC
   Prevents link navigation on wishlist button clicks,
   syncs heart states across all product cards,
   and keeps navbar count badges updated.
---------------------------------------------------- */
(function() {
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem('ks-wishlist')) || [];
    } catch(e) {
      return [];
    }
  }

  function syncAllWishlistButtons() {
    var wishlist = getWishlist();
    var wishlistedUrls = wishlist.map(function(item) {
      return (item.url || '').split('?')[0];
    });

    // Update all wishlist buttons
    document.querySelectorAll('wishlist-button, .card-wishlist-wrap, [class*="card-wishlist-wrap"]').forEach(function(wrap) {
      var url = wrap.dataset.productUrl || (wrap.querySelector('button') && wrap.querySelector('button').dataset.productUrl);
      if (!url) return;
      url = url.split('?')[0];

      var btn = wrap.querySelector('button') || wrap;
      if (!btn) return;

      var isWishlisted = wishlistedUrls.indexOf(url) > -1;
      if (isWishlisted) {
        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');
        btn.setAttribute('aria-label', (window.theme && window.theme.locales && window.theme.locales.wishlist && window.theme.locales.wishlist.remove) || 'Remove from Wishlist');
      } else {
        btn.classList.remove('active');
        btn.setAttribute('aria-pressed', 'false');
        btn.setAttribute('aria-label', (window.theme && window.theme.locales && window.theme.locales.wishlist && window.theme.locales.wishlist.add) || 'Add to Wishlist');
      }
    });

    // Also update any standalone wishlist buttons
    document.querySelectorAll('button.btn-wishlist, button[class*="wishlist-btn"], .img-btn-wishlist').forEach(function(btn) {
      var url = btn.dataset.productUrl || (btn.closest('wishlist-button') && btn.closest('wishlist-button').dataset.productUrl);
      if (!url) return;
      url = url.split('?')[0];

      var isWishlisted = wishlistedUrls.indexOf(url) > -1;
      if (isWishlisted) {
        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');
      } else {
        btn.classList.remove('active');
        btn.setAttribute('aria-pressed', 'false');
      }
    });

    // Sync header / navbar badges
    var badges = document.querySelectorAll('.wishlist-count-badge');
    var count = wishlist.length;
    badges.forEach(function(badge) {
      badge.textContent = count;
      badge.setAttribute('data-count', count);
      if (count > 0) {
        badge.classList.remove('is-zero');
        badge.style.display = 'inline-flex';
      } else {
        badge.classList.add('is-zero');
        badge.style.display = 'none';
      }
    });
  }

  // Intercept click on any wishlist button or icon
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('button.btn-wishlist, button[class*="wishlist-btn"], wishlist-button button, .img-btn-wishlist, wishlist-button');
    if (!btn) return;

    // Immediately stop propagation so click never bubbles to ancestor <a> cards or links!
    e.stopPropagation();

    // Prevent default on any parent link if nested inside <a>
    var parentLink = btn.closest('a');
    if (parentLink) {
      e.preventDefault();
    }

    // Determine target button and product URL
    var actualBtn = btn.tagName === 'BUTTON' ? btn : btn.querySelector('button');
    var wrap = btn.closest('wishlist-button') || btn;
    var productUrl = (wrap && wrap.dataset.productUrl) || (actualBtn && actualBtn.dataset.productUrl);

    // If wishlist-container setProduct didn't fire (e.g. standalone button without customElement), trigger it:
    if (!btn.closest('wishlist-button')) {
      e.preventDefault();
      var container = document.querySelector('wishlist-container');
      if (container && typeof container.setProduct === 'function' && productUrl) {
        container.setProduct(productUrl).then(function() {
          syncAllWishlistButtons();
        });
      }
    }

    // Delay sync to let standard WishlistButton complete
    setTimeout(syncAllWishlistButtons, 150);
    setTimeout(syncAllWishlistButtons, 500);
  }, false);

  // Initial sync on load and DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllWishlistButtons);
  } else {
    syncAllWishlistButtons();
  }

  // Secondary syncs after DOM settles
  window.addEventListener('load', syncAllWishlistButtons);
  setTimeout(syncAllWishlistButtons, 400);
  setTimeout(syncAllWishlistButtons, 1200);

  // Sync across tabs
  window.addEventListener('storage', function(e) {
    if (e.key === 'ks-wishlist') {
      syncAllWishlistButtons();
    }
  });
})();

/* ----------------------------------------------------
   JUDGE.ME REVIEWS: AUTO SMOOTH SCROLL ON PAGINATION
   Ensures that clicking page numbers or next/prev smoothly
   scrolls the user right to the top of the reviews section,
   never throwing them down the page.
---------------------------------------------------- */
(function() {
  function scrollToReviewsHeader() {
    var reviewSection = document.querySelector('.jdgm-review-widget, .jdgm-rev-widg, [id*="1787554915e13fbd7e"]');
    if (!reviewSection) return;

    // Account for sticky header so the review title isn't covered
    var header = document.querySelector('.site-header, #site-header, header, .navbar, .sticky-top');
    var headerHeight = header ? header.offsetHeight : 70;

    var targetEl = reviewSection.querySelector('.jdgm-rev-widg__title') || reviewSection;
    var rect = targetEl.getBoundingClientRect();
    var targetY = window.pageYOffset + rect.top - (headerHeight + 20);

    window.scrollTo({
      top: Math.max(0, targetY),
      behavior: 'smooth'
    });
  }

  function ensureJudgemeId() {
    var widget = document.querySelector('.jdgm-review-widget, .jdgm-rev-widg');
    if (widget && !document.getElementById('judgeme_product_reviews')) {
      widget.id = 'judgeme_product_reviews';
    }
  }

  // Intercept click on any pagination link/button in Judge.me
  document.addEventListener('click', function(e) {
    var pageBtn = e.target.closest('.jdgm-paginate a, .jdgm-paginate__page, .jdgm-paginate__first-page, .jdgm-paginate__prev-page, .jdgm-paginate__next-page, .jdgm-paginate__last-page');
    if (pageBtn) {
      ensureJudgemeId();

      // Smoothly scroll to the top of reviews immediately
      scrollToReviewsHeader();

      // Also ensure position after Judge.me finishes replacing DOM
      setTimeout(scrollToReviewsHeader, 350);
      setTimeout(scrollToReviewsHeader, 700);
    }
  }, true);

  // Hook into Judge.me custom events if present
  window.addEventListener('jdgm.afterPagination', scrollToReviewsHeader);
  window.addEventListener('jdgm.doneSetup', ensureJudgemeId);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureJudgemeId);
  } else {
    ensureJudgemeId();
  }
})();